export default function getQueryParam(key, base = window.location.search) {
    const qst = base;
    return qst.slice(
        qst.indexOf(key + "=") + key.length + 1,
        qst.slice(qst.indexOf(key + "=") + key.length + 1).indexOf("&") !== -1
            ? qst.slice(qst.indexOf(key + "=") + key.length + 1).indexOf("&") + key.length + 2
            : qst.length
    );
}
